type GuestPickerTranslations = {
    guests: string;
    adults: string;
    age: string;
    children: string;
    child: string;
    ageDescriptionAdults: string;
    ageDescriptionChildren: string;
}

export default function getGuestPickerTranslations(language: string): GuestPickerTranslations {
    if (language === "fr-FR") return {
      guests: "Invités",
      adults: "adultes",
      age: "âge",
      children: "enfants",
      child: "Enfant",
      ageDescriptionAdults: "Âges {age} ans ou plus",
      ageDescriptionChildren: "Âges {age}",
    }
    if(language === "en-US") return {
      guests: "Guests",
      adults: "Adults",
      age: "age",
      children: "Children",
      child: "Child",
      ageDescriptionAdults: "Ages {age} or above",
      ageDescriptionChildren: "Ages {age}",
    }
    if(language === "nb-NO" || language === "no-NO") return {
      guests: "Gjester",
      adults: "Voksne",
      age: "alder",
      children: "Barn",
      child: "Barn",
      ageDescriptionAdults: "{age} år eller eldre",
      ageDescriptionChildren: "Alderen {age}",
    }
    return {
      guests: "Guests",
      adults: "Adults",
      age: "age",
      children: "Children",
      child: "Child",
      ageDescriptionAdults: "Ages {age} or above",
      ageDescriptionChildren: "Ages {age}",
    }
}
  